import { useState, useEffect } from 'react';
import './candidateawards.css';
import { faChevronDown, faChevronUp, faEdit, faMinusCircle, faPen, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row, Modal, Form } from 'react-bootstrap';
import TrophyIcon from '../../../../assets/images/noun-trophy-1860077 1.png';
import CandidateAwardInfoPanel from './candidateAwardsInfoPanel';
import { CandidatePostLoginService } from '../../../../services/candidatePostLoginService';
import { CandidateService } from '../../../../services/candidateService';
import ClientUserService from '../../../../services/client-services/clientUserService';
import ReactDatePicker from 'react-datepicker';
import CloseIcon from '../../../../assets/images/Ic_close.png';
import { decodeJWT } from '../../../../services/candidateService';


const CandidateAwardsInfo = ({ awardDocs = [], candidateData, fetchCandidateData }) => {
  const token = window.localStorage.getItem('authToken');
  const decoded = decodeJWT(token);
  const candidateId = _.get(decoded, 'username', '');
  if (!candidateId || typeof candidateId !== 'string') {
    alert('Invalid token or missing candidate ID');
    return;
  }
  const [showAll, setShowAll] = useState(false);
  const [editedAwards, setEditedAwards] = useState([]);
  const [editingIndexes, setEditingIndexes] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [originalAwards, setOriginalAwards] = useState({});
  const [newAwards, setNewAwards] = useState([]);
  const [currentAward, setCurrentAward] = useState(null);
  const [savingAwards, setSavingAwards] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errors, setErrors] = useState({});
  const [removedEditedAwardIndexes, setRemovedEditedAwardIndexes] = useState([]);
  const [awardFiles, setAwardFiles] = useState({});
  const [newAwardFiles, setNewAwardFiles] = useState({});
  const [removedAwardFiles, setRemovedAwardFiles] = useState({});
  const [isCurrentAwardRemoved, setIsCurrentAwardRemoved] = useState(false);

  const isEditMode =
    editingIndexes.length === 1 &&
    currentAward;

  const downloadFile = (path, fileName) => {
    if (!path) {
      console.error("Missing file path");
      return;
    }
    ClientUserService.downloadFile(encodeURI(path))
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => console.error(err));
  };

  const handleRemoveEditedAward = (index) => {
    setRemovedEditedAwardIndexes(prev => [...prev, index]);
    setIsCurrentAwardRemoved(true);
  };


  const validateField = (index, field, value, isNew = false) => {
    const val = (value || '').toString().trim();

    if (val === '') {
      setErrors(prev => {
        const newErrors = { ...prev };
        const key = `${isNew ? 'new' : 'edit'}_${field}_${index}`;
        delete newErrors[key];
        return newErrors;
      });
      return;
    }

    let error = '';

    switch (field) {
      case 'title':
        if (val.length < 2 || val.length > 100) {
          error = 'Award Title must be 2–100 characters.';
        }
        break;

      case 'providedBy':
        if (val.length < 2 || val.length > 100) {
          error = 'Provided By must be 2–100 characters.';
        }
        break;

      case 'issueYear':
        if (!/^\d{4}$/.test(val) || Number(val) > new Date().getFullYear()) {
          error = 'Please select a valid year (not in the future).';
        }
        break;

      default:
        break;
    }

    setErrors(prev => {
      const newErrors = { ...prev };
      const key = `${isNew ? 'new' : 'edit'}_${field}_${index}`;
      if (error) {
        newErrors[key] = error;
      } else {
        delete newErrors[key];
      }
      return newErrors;
    });
  };


  useEffect(() => {
    setEditedAwards(Array.isArray(awardDocs) ? awardDocs : []);
  }, [awardDocs]);

  const validAwards = editedAwards;
  const visibleAwards = showAll ? validAwards : validAwards.slice(0, 2);

  const handleAddForm = () => {
    setNewAwards(prev => [
      ...prev,
      { title: '', providedBy: '', issueYear: '' }
    ]);
    setModalVisible(true);
  };


  const handleNewFieldChange = (index, field, value) => {
    const updated = [...newAwards];
    updated[index] = { ...updated[index], [field]: value };
    setNewAwards(updated);
  };

  const handleRemoveNewAward = (index) => {
    setNewAwards(prev => prev.filter((_, i) => i !== index));
  };

  const handleEdit = (index) => {
    setOriginalAwards(prev => ({
      ...prev,
      [index]: JSON.parse(JSON.stringify(editedAwards[index]))
    }));
    setCurrentAward(JSON.parse(JSON.stringify(editedAwards[index])));
    setEditingIndexes([index]);
    setModalVisible(true);
    setIsCurrentAwardRemoved(false);
  };


  const handleSave = async () => {
    setSavingAwards(true);

    const hasValidationErrors = Object.keys(errors).some((key) => errors[key]);
    if (hasValidationErrors) {
      setErrorMessage("Please fix the field-level validation errors before saving.");
      setSavingAwards(false);
      return;
    }

    let updatedAwards = editedAwards.filter((_, i) => !removedEditedAwardIndexes.includes(i));

    if (editingIndexes.length === 1 && currentAward && !removedEditedAwardIndexes.includes(editingIndexes[0])) {
      // const { title, providedBy, issueYear } = currentAward;
      // const allEmpty = !title && !providedBy && !issueYear;

      // if (allEmpty) {
      //   setErrorMessage('Please fill at least one of the award fields (Title, Provided By, Issue Year, etc.) before saving.');
      //   setSavingAwards(false);
      //   return;
      // }

      const index = editingIndexes[0];
      updatedAwards[index] = currentAward;
    }

    // for (let i = 0; i < newAwards.length; i++) {
    //   const award = newAwards[i];
    //   const allEmpty = !award.title && !award.providedBy && !award.issueYear;
    //   if (allEmpty) {
    //     setErrorMessage(`Please fill at least one field for Award ${i + 1} before saving.`);
    //     setSavingAwards(false);
    //     return;
    //   }
    // }

    const uploadAwardDoc = (file) => {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append('file', file);

        const fileUploadHandler = (data) => {
          if (data && !data.error) {
            resolve(data);
          } else {
            reject(data.error || 'Upload failed');
          }
        };

        CandidateService.uploadFile(formData, 'AWARD', fileUploadHandler, () => { });
      });
    };

    try {
      for (let i = 0; i < updatedAwards.length; i++) {
        if (awardFiles[i]) {
          const uploaded = await uploadAwardDoc(awardFiles[i]);
          updatedAwards[i].awardDoc = [uploaded];
        }
      }

      updatedAwards = updatedAwards.map(a => {
        if (a.id === null) {
          const { id, ...rest } = a;
          return rest;
        }
        return a;
      });

      const newAwardObjects = [];

      for (let i = 0; i < newAwards.length; i++) {
        const baseAward = { ...newAwards[i] };

        const awardToPush = {
          ...baseAward,
        };

        if (newAwardFiles[i]) {
          const uploaded = await uploadAwardDoc(newAwardFiles[i]);
          awardToPush.awardDoc = [uploaded];
        }

        newAwardObjects.push(awardToPush);
      }

      updatedAwards = [...updatedAwards, ...newAwardObjects];
      updatedAwards = updatedAwards.map((award, i) => {
        const updated = { ...award };

        if (removedAwardFiles[i]) {
          updated.awardDoc = [];
        }

        return updated;
      });

      const finalPayload = updatedAwards.map(a => {
        const base = {
          title: a.title,
          providedBy: a.providedBy,
          issueYear: a.issueYear,
        };

        if (Array.isArray(a.awardDoc) && a.awardDoc.length > 0) {
          base.awardDoc = a.awardDoc.map(doc => ({
            originalName: doc.originalName,
            path: doc.path,
            fileSize: doc.fileSize,
            fileSizeUnit: doc.fileSizeUnit,
          }));
        }

        return base;
      });

      setEditedAwards(updatedAwards);
      setEditingIndexes([]);
      setCurrentAward(null);
      setNewAwards([]);
      setModalVisible(false);
      setRemovedEditedAwardIndexes([]);
      setErrorMessage('');

      // await CandidatePostLoginService.submitAwards(finalPayload);
      await CandidatePostLoginService.submitPanelByType('AWARDS', {
        inputName: 'awards',
        inputList: finalPayload
      });

      await fetchCandidateData();
      setRemovedAwardFiles({});

    } catch (error) {
      console.error('Failed to save awards:', error.response?.data || error.message);
    } finally {
      setSavingAwards(false);
    }
  };

  const handleCancel = () => {
    if (editingIndexes.length === 1) {
      const index = editingIndexes[0];
      setEditedAwards(prev => {
        const updated = [...prev];
        if (originalAwards[index]) {
          updated[index] = originalAwards[index];
        }
        return updated;
      });
      setEditingIndexes([]);
      setOriginalAwards(prev => {
        const updated = { ...prev };
        delete updated[index];
        return updated;
      });
    }
    setIsCurrentAwardRemoved(false);
    setEditingIndexes([]);
    setErrors({});
    setNewAwards([]);
    setModalVisible(false);
  };

  const getGlobalAwardNumber = (index, isNew = false) =>
    (editedAwards?.length || 0) + (isNew ? index + 1 : 0);

  return (
    <>
      {errorMessage && (
        <div className="custom-alert-overlay">
          <div className="custom-alert-box">
            <div className="custom-alert-content">
              <p>{errorMessage}</p>
              <button className="custom-alert-button" onClick={() => setErrorMessage('')}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal show={modalVisible} onHide={handleCancel} centered backdrop="static" className="candidate-custom-modal" dialogClassName="candidate-custom-modal-dialog">
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title>{isEditMode ? 'Edit Award Info' : 'Add Award Info'}</Modal.Title>
          <img
            src={CloseIcon}
            alt="Close"
            onClick={handleCancel}
            style={{
              cursor: 'pointer',
              width: '24px',
              height: '24px',
            }}
          />
        </Modal.Header>
        <Modal.Body>
          <style>
            {`
    .react-datepicker__input-container input {
      border: 1px solid #ced4da !important;
      box-shadow: none !important;
    }

    .react-datepicker__input-container input:focus {
      border: 1px solid #ced4da !important;
      box-shadow: none !important;
      outline: none;
    }
  `}
          </style>
          {editingIndexes.length === 1 && currentAward && (
            <>

              <h5 className="mb-3">
                Award – {editingIndexes.length === 1 ? editingIndexes[0] + 1 : ''}
              </h5>
              {isCurrentAwardRemoved && (
                <div
                  className="alert alert-warning mt-2 mb-3"
                  style={{ padding: '8px 12px', fontSize: '0.9rem' }}
                >
                  This award will be removed once you click save.
                </div>
              )}
              {!isCurrentAwardRemoved && (
                <>
                  <div className="mb-3">

                    <label className="form-label">Award Title</label>
                    <input
                      style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                      type="text"
                      spellCheck='false'
                      className={`form-control ${errors[`edit_title_${editingIndexes[0]}`] ? 'is-invalid' : ''}`}
                      value={currentAward.title || ''}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCurrentAward({ ...currentAward, title: value });
                        validateField(editingIndexes[0], 'title', value, false);
                      }}
                    />
                    {errors[`edit_title_${editingIndexes[0]}`] && (
                      <div className="invalid-feedback">{errors[`edit_title_${editingIndexes[0]}`]}</div>
                    )}

                  </div>
                  <div className="mb-3">
                    <label className="form-label">Provided By</label>
                    <input
                      style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                      type="text"
                      spellCheck='false'
                      className={`form-control ${errors[`edit_providedBy_${editingIndexes[0]}`] ? 'is-invalid' : ''}`}
                      value={currentAward.providedBy || ''}
                      onChange={(e) => {
                        const value = e.target.value;
                        setCurrentAward({ ...currentAward, providedBy: value });
                        validateField(editingIndexes[0], 'providedBy', value, false);
                      }}
                    />
                    {errors[`edit_providedBy_${editingIndexes[0]}`] && (
                      <div className="invalid-feedback">{errors[`edit_providedBy_${editingIndexes[0]}`]}</div>
                    )}
                  </div>
                  <div className="mb-3">
                    <Form.Group className="mb-3">
                      <Form.Label>
                        Issue Year
                      </Form.Label>
                      <ReactDatePicker
                        selected={
                          currentAward.issueYear ? new Date(currentAward.issueYear, 0) : null
                        }
                        onChange={(val) => {
                          if (val) {
                            const year = val.getFullYear();
                            setCurrentAward(prev => ({ ...prev, issueYear: year }));
                            validateField(editingIndexes[0], 'issueYear', year, false);
                          } else {
                            setCurrentAward(prev => ({ ...prev, issueYear: '' }));
                            validateField(editingIndexes[0], 'issueYear', '', false);
                          }
                        }}
                        showYearPicker
                        dateFormat="yyyy"
                        className={`form-control ${errors[`edit_issueYear_${editingIndexes[0]}`] ? 'is-invalid' : ''}`}
                        maxDate={new Date()}
                        autoComplete="off"
                      />

                      {errors[`edit_issueYear_${editingIndexes[0]}`] && (
                        <div className="invalid-feedback d-block">{errors[`edit_issueYear_${editingIndexes[0]}`]}</div>
                      )}
                    </Form.Group>
                  </div>
                  <div className="mb-3">
                    <div className="custom-file-wrapper">
                      <input
                        type="file"
                        accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                        className="form-control"
                        style={{ position: 'relative', zIndex: 2 }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setAwardFiles(prev => ({ ...prev, [editingIndexes[0]]: file }));
                          }
                        }}
                      />

                      <div className="mt-1" style={{ fontSize: '0.9rem', color: '#555' }}>
                        {awardFiles[editingIndexes[0]] ? (
                          <span>
                            Selected: {awardFiles[editingIndexes[0]].name}
                            <button
                              type="button"
                              className="btn btn-sm btn-link text-danger ms-2 p-0"
                              onClick={() =>
                                setAwardFiles(prev => {
                                  const updated = { ...prev };
                                  delete updated[editingIndexes[0]];
                                  return updated;
                                })
                              }
                            >
                              Remove
                            </button>
                          </span>
                        ) : currentAward?.awardDoc?.length > 0 && !removedAwardFiles[editingIndexes[0]] ? (
                          <span>
                            Uploaded:&nbsp;
                            <button
                              type="button"
                              onClick={() =>
                                downloadFile(
                                  currentAward.awardDoc[0]?.path,
                                  currentAward.awardDoc[0]?.originalName
                                )
                              }
                              className="btn btn-link p-0"
                              style={{ fontSize: '0.9rem', color: '#F35824' }}
                            >
                              {currentAward.awardDoc[0]?.originalName}
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-link text-danger ms-2 p-0"
                              onClick={() =>
                                setRemovedAwardFiles(prev => ({ ...prev, [editingIndexes[0]]: true }))
                              }
                            >
                              <span
                                style={{ fontWeight: '500', color: '#F35824', cursor: 'pointer' }}
                              >
                                <FontAwesomeIcon icon={faMinusCircle} />
                              </span>
                            </button>
                          </span>
                        ) : (
                          <span>No file chosen</span>
                        )}

                      </div>
                    </div>

                  </div>

                  {isEditMode && editedAwards.length > 0 && (
                    <div className="d-flex justify-content-end mt-3">
                      <span
                        style={{ fontWeight: '500', color: '#F35824', cursor: 'pointer' }}
                        onClick={() => handleRemoveEditedAward(editingIndexes[0])}
                      >
                        <FontAwesomeIcon icon={faMinusCircle} />
                      </span>
                    </div>
                  )}
                </>
              )}
            </>

          )}

          {newAwards.map((award, index) => (
            <div key={`new-award-${index}`} className="mb-3">
              <h5>
                Award – {getGlobalAwardNumber(index, true)}
              </h5>

              <div className="mb-3">
                <label className="form-label">Award Title</label>
                <input
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  type="text"
                  spellCheck='false'
                  className={`form-control ${errors[`new_title_${index}`] ? 'is-invalid' : ''}`}
                  value={award.title || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleNewFieldChange(index, 'title', value);
                    validateField(index, 'title', value, true);
                  }}
                />
                {errors[`new_title_${index}`] && (
                  <div className="invalid-feedback">{errors[`new_title_${index}`]}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">Provided By</label>
                <input
                  style={{ boxShadow: 'none', border: '1px solid #ced4da' }}
                  type="text"
                  spellCheck='false'
                  className={`form-control ${errors[`new_providedBy_${index}`] ? 'is-invalid' : ''}`}
                  value={award.providedBy || ''}
                  onChange={(e) => {
                    const value = e.target.value;
                    handleNewFieldChange(index, 'providedBy', value);
                    validateField(index, 'providedBy', value, true);
                  }}
                />
                {errors[`new_providedBy_${index}`] && (
                  <div className="invalid-feedback">{errors[`new_providedBy_${index}`]}</div>
                )}
              </div>
              <div className="mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>Issue Year</Form.Label>
                  <ReactDatePicker
                    selected={
                      award.issueYear ? new Date(new Date().setFullYear(award.issueYear)) : null
                    }
                    onChange={(val) => {
                      if (val) {
                        const year = val.getFullYear();
                        handleNewFieldChange(index, 'issueYear', year);
                        validateField(index, 'issueYear', year, true);
                      } else {
                        handleNewFieldChange(index, 'issueYear', null);
                        validateField(index, 'issueYear', null, true);
                      }
                    }}
                    showYearPicker
                    dateFormat="yyyy"
                    className={`form-control ${errors[`new_issueYear_${index}`] ? 'is-invalid' : ''}`}
                    maxDate={new Date()}
                    autoComplete="off"
                  />
                  {errors[`new_issueYear_${index}`] && (
                    <div className="invalid-feedback d-block">{errors[`new_issueYear_${index}`]}</div>
                  )}


                </Form.Group>

              </div>

              <div className="mb-3">
                <label className="form-label">Upload Award Document (optional)</label>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
                  className="form-control"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setNewAwardFiles(prev => ({ ...prev, [index]: file }));
                    }
                  }}
                />
              </div>
              {isEditMode && (
                <div className="d-flex justify-content-end mt-3">
                  <span
                    style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
                    onClick={() => handleRemoveNewAward(index)}
                  >
                    <FontAwesomeIcon icon={faMinusCircle} />
                  </span>
                </div>
              )}
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <button onClick={handleCancel}
            className="candidate-profile-edit-cancel"
            disabled={savingAwards}
          >
            Cancel
          </button>
          <button onClick={handleSave}
            className="candidate-profile-edit-save"
            disabled={savingAwards}
          >
            {savingAwards ? 'Saving...' : 'Save'}
          </button>

        </Modal.Footer>
      </Modal>

      <Container className="pt-2 candidate-awards-container">
        <Row className="align-items-center mb-3">
          <Col className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <h3 className="candidate-heading mb-0 me-2">
                Awards ({validAwards.length})
                <img
                  src={TrophyIcon}
                  alt="Trophy"
                  className="profile-work-experience-nav-icon"
                />
              </h3>
            </div>

            <div
              style={{ color: '#F35824', cursor: 'pointer', fontWeight: '500' }}
              className='candidate-detail-add-head'
              onClick={() => {
                setCurrentAward(null);
                setEditingIndexes([]);
                setNewAwards([{ title: '', providedBy: '', issueYear: '', awardDoc: [] }]);
                setModalVisible(true);
              }}
            >
              <FontAwesomeIcon icon={faPlusCircle} /> Add Award
            </div>
          </Col>
        </Row>


        <Container>
          {visibleAwards.map((award, index) => (
            <div key={`award-${index}`} className="d-flex justify-content-between align-items-start mb-3">
              <div style={{ flex: 1 }}>
                <CandidateAwardInfoPanel
                  colorSeed={Math.random()}
                  award={award}
                  downloadFile={downloadFile}
                />
              </div>
              <div className="ms-3 mt-1">
                <button onClick={() => handleEdit(index)} className="candidate-profile-edit-button">
                  <FontAwesomeIcon icon={faPen} />
                </button>
              </div>
            </div>
          ))}
        </Container>

        {validAwards.length > 2 && (
          <Row>
            <Col>
              <a
                className="candidate-awards-view-all"
                onClick={() => setShowAll(prev => !prev)}
              >
                {showAll ? 'View Less' : 'View All'}{' '}
                <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
              </a>
            </Col>
          </Row>
        )}



      </Container>
    </>
  );
};

export default CandidateAwardsInfo;